import moment from 'moment';
import lodash from 'lodash';

export const months = {
  apr:"",
  may:"",
  jun:"",
  jul:"",
  aug:"",
  sep:"",
  oct:"",
  nov:"",
  dec:"",
  jan:"",
  feb:"",
  mar:"",
}
export const processes = [
  {
    sNo:"A",
    area_of_process:"Industrial area",
    area_of_functions:"Press Shop (Sheet Metal )",
    avg_noise_db:"75 ~70",
    ...months,
    remarks: ''
  },
  {
    sNo:"B",
    area_of_process:"Commercial area",
    area_of_functions:"Admin ,Stair & Account",
    avg_noise_db:"65 ~55",
    ...months,
    remarks: ''
  },
  {
    sNo:"C",
    area_of_process:"Residential area",
    area_of_functions:"Out side the Permises",
    avg_noise_db:"55 ~45",
    ...months,
    remarks: ''
  },
  {
    sNo:"D",
    area_of_process:"Silence Zone",
    area_of_functions:"Meeting Room",
    avg_noise_db:"50 ~40",
    ...months,
    remarks: ''
  },
  
];

export const initialState = {
  isSubmitted: false,
  report_prepared_by: null,
  report_approved_by: null,
  status:null,
  processes: lodash.cloneDeep(processes),
};
